import _ from 'lodash';
import sm from '@editor/droplets/social-media/droplet.schema';
const socialMedia = sm();

const legacyChecks = {
  computed: {
    isSocialMedia() {
      return this.activeDroplet.type === 'droplet.socialMedia';
    },
    isFooterNav() {
      return this.activeDroplet.type === 'droplet.footerNav';
    },
    isYouTube() {
      return this.activeDroplet.type === 'droplet.youTubeVideo';
    },
    isCard() {
      return this.activeDroplet.type.match(/^droplet\.cards/gi);
    },
  },
  methods: {
    checkLegacyStyles(payload) {
      // this is used to remove old section styles so we do not have duplicates
      // now that sections adopted the way other droplets handle mediaQueries.
      // if there are duplicates, injected CSS will output the old styles
      if (this.isSection) {
        this.sectionLegacyChecks(payload);
      } else {
        // for all droplets, we need to see if there are legacy background-colors
        this.bgColorLegacyChecks(payload);
      }
      // old align styles need to be removed as well for certain droplets
      if (this.isSocialMedia) {
        this.socialMediaLegacyChecks(payload);
      }
      // there are legacy footer nav margin's that would need to be removed for the new align method
      if (this.isFooterNav) {
        this.footerNavLegacyChecks(payload);
      }
      // the youtube droplet used a depricated class approach that could break the new method
      if (this.isYouTube) {
        this.youTubeLegacyChecks(payload);
      }
      if (this.isCard) {
        this.cardLegacyChecks(payload);
      }
    },
    getRule(params) {
      let index = -1;
      const selector = _.find(this.activeDroplet.mediaQueries, { selector: params.selector });
      if (selector) {
        index = _.findIndex(selector.properties, r => r.property === params.property);
      }
      return { index, selector };
    },
    sectionLegacyChecks(payload) {
      if (payload.selector === ' ') {
        const i = _.findIndex(
          this.activeDroplet.mediaQueries, drp => drp.property === payload.property,
        );
        if (i >= 0 && !this.activeDroplet.mediaQueries[i].selector) {
          this.$store.dispatch('spliceDropletVal', {
            index: i,
            array: this.activeDroplet.mediaQueries,
          });
        }
        if (payload.property === 'background') {
          // need to remove all old background type rules using old mediaQueries method
          let position = _.findIndex(this.activeDroplet.mediaQueries, r => r.property === 'background-position');
          if (position >= 0) {
            this.$store.dispatch('spliceDropletVal', {
              index: position,
              array: this.activeDroplet.mediaQueries,
            });
          }
          let repeat = _.findIndex(this.activeDroplet.mediaQueries, r => r.property === 'background-repeat');
          if (repeat >= 0) {
            this.$store.dispatch('spliceDropletVal', {
              index: repeat,
              array: this.activeDroplet.mediaQueries,
            });
          }
          let size = _.findIndex(this.activeDroplet.mediaQueries, r => r.property === 'background-size');
          if (size >= 0) {
            this.$store.dispatch('spliceDropletVal', {
              index: size,
              array: this.activeDroplet.mediaQueries,
            });
          }
          let color = _.findIndex(this.activeDroplet.mediaQueries, r => r.property === 'background-color');
          if (color >= 0) {
            this.$store.dispatch('spliceDropletVal', {
              index: color,
              array: this.activeDroplet.mediaQueries,
            });
          }
          // also need to remove old mediaQueries using selector
          position = this.getRule({ selector: ' ', property: 'background-position' });
          if (position.index >= 0) {
            this.$store.dispatch('spliceDropletVal', {
              index: position.index,
              array: position.selector.properties,
            });
          }
          repeat = this.getRule({ selector: ' ', property: 'background-repeat' });
          if (repeat.index >= 0) {
            this.$store.dispatch('spliceDropletVal', {
              index: repeat.index,
              array: repeat.selector.properties,
            });
          }
          size = this.getRule({ selector: ' ', property: 'background-size' });
          if (size.index >= 0) {
            this.$store.dispatch('spliceDropletVal', {
              index: size.index,
              array: size.selector.properties,
            });
          }
          color = this.getRule({ selector: ' ', property: 'background-color' });
          if (color.index >= 0) {
            this.$store.dispatch('spliceDropletVal', {
              index: color.index,
              array: color.selector.properties,
            });
          }
        }
      }
    },
    footerNavLegacyChecks(payload) {
      // there are legacy footer nav margin's that would need to be removed for the new align method
      if (payload.selector === '.drzFooterNav-list' && payload.property === 'float') {
        const mlRule = this.getRule({ selector: '.drzFooterNav-list-item', property: 'margin-left' });
        if (mlRule.index >= 0) {
          this.$store.dispatch('spliceDropletVal', {
            index: mlRule.index,
            array: mlRule.selector.properties,
          });
        }
        const mrRule = this.getRule({ selector: '.drzFooterNav-list-item', property: 'margin-right' });
        if (mrRule.index >= 0) {
          this.$store.dispatch('spliceDropletVal', {
            index: mrRule.index,
            array: mrRule.selector.properties,
          });
        }
      }
    },
    cardLegacyChecks(payload) {
      if (payload.property === 'background-image') {
        const rule = this.getRule({ selector: `#drp-${payload.drp._id}`, property: 'background-image' });
        if (rule.index >= 0) {
          this.$store.dispatch('spliceDropletVal', {
            index: rule.index,
            array: rule.selector.properties,
          });
        }
      }
    },
    bgColorLegacyChecks(payload) {
      if (payload.property === 'background') {
        // need to remove old background-color rules
        const rule = this.getRule({ selector: payload.selector, property: 'background-color' });
        if (rule.index >= 0) {
          this.$store.dispatch('spliceDropletVal', {
            index: rule.index,
            array: rule.selector.properties,
          });
        }
      }
    },
    youTubeLegacyChecks(payload) {
      if (this.activeDroplet.align !== 'left' && payload.selector === '.drzYouTubeVideo' && payload.property === 'float') {
        this.$store.dispatch('setDropletVal', {
          drp: this.activeDroplet,
          key: 'align',
          val: 'left',
        });
      }
    },
    socialMediaLegacyChecks(payload) {
      // old align styles need to be removed as well for certain droplets
      if (payload.property === 'margin-right') {
        const rule = this.getRule({ selector: '[class^=\'drzSocialMedia-icon\']', property: 'margin-left' });
        if (rule.index >= 0) {
          this.$store.dispatch('spliceDropletVal', {
            index: rule.index,
            array: rule.selector.properties,
          });
        }
      }
      if (payload.property === 'background-color' || payload.property === 'color') {
        const queries = this.activeDroplet.mediaQueries;
        for (let i = queries.length - 1; i >= 0; --i) {
          const mq = queries[i];
          const exists = _.find(socialMedia.socialIcons, icon => mq.selector.match(icon.cls));
          if (exists) {
            this.$store.dispatch('spliceDropletVal', {
              index: i,
              array: this.activeDroplet.mediaQueries,
            });
          }
        }
      }
      if (this.activeDroplet.wrapClassList && payload.property === 'text-align') {
        // erase all depricated wrap classes as it may break new method
        if (this.activeDroplet.wrapClassList.length > 0) {
          this.$store.dispatch('setDropletVal', {
            drp: this.activeDroplet,
            key: 'wrapClassList',
            val: [],
          });
        }
      }
    },
  },
};

export { legacyChecks };



// WEBPACK FOOTER //
// ./src/global-view/editor/page/style-sidebar/mixins/legacy-checks.js